/* Sasha Jameson — theme.js (vanilla, no dependencies) */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const T = window.theme || {};

  /* ---------- Money ---------- */
  const formatMoney = (cents) => {
    const fmt = T.moneyFormat || '£{{amount}}';
    const n = (cents / 100);
    const two = n.toFixed(2);
    const withCommas = (v, sep = ',', dec = '.') => {
      const [i, d] = v.split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, sep) + (d ? dec + d : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      switch (k) {
        case 'amount_no_decimals': return withCommas(Math.round(n).toString());
        case 'amount_with_comma_separator': return withCommas(two, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withCommas(Math.round(n).toString(), '.');
        default: return withCommas(two);
      }
    });
  };

  /* ---------- Header: transparent → solid on scroll ---------- */
  const header = $('[data-header]');
  const bar = $('#AnnouncementBar');
  const onScroll = () => {
    const scrolled = window.scrollY > 100;
    document.body.classList.toggle('is-scrolled', scrolled);
    if (header) {
      const transparent = header.dataset.transparent === 'true' && !scrolled && !document.body.classList.contains('mega-open');
      header.classList.toggle('is-solid', !transparent);
    }
    if (bar) bar.style.transform = scrolled ? 'translateY(-100%)' : '';
    const btt = $('[data-back-to-top]');
    if (btt) { btt.style.opacity = window.scrollY > 600 ? '1' : '0'; btt.style.pointerEvents = window.scrollY > 600 ? 'auto' : 'none'; }
  };
  if (bar) document.body.classList.add('has-announcement');
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
  $('[data-back-to-top]')?.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  $('[data-scroll-next]')?.addEventListener('click', () => window.scrollTo({ top: window.innerHeight, behavior: 'smooth' }));

  /* ---------- Announcement rotation ---------- */
  if (bar) {
    const items = $$('[data-announcement]', bar);
    if (items.length > 1) {
      let i = 0;
      setInterval(() => {
        items[i].classList.add('opacity-0', '-translate-y-2');
        i = (i + 1) % items.length;
        items[i].classList.remove('opacity-0', '-translate-y-2');
      }, (parseInt(bar.dataset.rotate, 10) || 5) * 1000);
    }
  }

  /* ---------- Mega menu ---------- */
  $$('[data-mega-trigger]').forEach((trigger) => {
    const panel = document.getElementById(trigger.dataset.megaTrigger);
    if (!panel) return;
    let t;
    const open = () => {
      clearTimeout(t);
      $$('[data-mega-panel]').forEach((p) => p !== panel && p.classList.remove('is-open'));
      panel.style.top = (header.getBoundingClientRect().bottom) + 'px';
      panel.classList.add('is-open');
      document.body.classList.add('mega-open');
      trigger.querySelector('a')?.setAttribute('aria-expanded', 'true');
      onScroll();
    };
    const close = () => {
      t = setTimeout(() => {
        panel.classList.remove('is-open');
        document.body.classList.remove('mega-open');
        trigger.querySelector('a')?.setAttribute('aria-expanded', 'false');
        onScroll();
      }, 120);
    };
    [trigger, panel].forEach((el) => { el.addEventListener('mouseenter', open); el.addEventListener('mouseleave', close); });
    trigger.addEventListener('focusin', open);
    panel.addEventListener('focusout', (e) => { if (!panel.contains(e.relatedTarget)) close(); });
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('[data-mega-panel]').forEach((p) => p.classList.remove('is-open'));
    document.body.classList.remove('mega-open');
    closeDrawer(); closeMobile(); closeSearch();
    const z = $('#ZoomModal'); if (z) { z.classList.add('hidden'); z.classList.remove('flex'); }
  });

  /* ---------- Generic off-canvas helpers ---------- */
  const toggleLayer = (root, panelSel, hiddenCls, on) => {
    if (!root) return;
    root.classList.toggle('pointer-events-none', !on);
    root.setAttribute('aria-hidden', on ? 'false' : 'true');
    root.querySelector('[data-cart-overlay],[data-mobile-overlay]')?.classList.toggle('opacity-0', !on);
    root.querySelector(panelSel)?.classList.toggle(hiddenCls, !on);
    document.documentElement.classList.toggle('overflow-hidden', on);
  };

  /* Mobile menu */
  const mobile = $('#MobileMenu');
  const openMobile = () => toggleLayer(mobile, 'nav', '-translate-x-full', true);
  const closeMobile = () => toggleLayer(mobile, 'nav', '-translate-x-full', false);
  $('[data-mobile-open]')?.addEventListener('click', openMobile);
  $('[data-mobile-close]')?.addEventListener('click', closeMobile);
  mobile?.querySelector('[data-mobile-overlay]')?.addEventListener('click', closeMobile);

  /* ---------- Search overlay + predictive search ---------- */
  const search = $('#SearchOverlay');
  const openSearch = () => {
    if (!search) return;
    search.classList.remove('opacity-0', 'pointer-events-none');
    search.setAttribute('aria-hidden', 'false');
    setTimeout(() => $('[data-search-input]', search)?.focus(), 50);
  };
  const closeSearch = () => {
    if (!search) return;
    search.classList.add('opacity-0', 'pointer-events-none');
    search.setAttribute('aria-hidden', 'true');
  };
  $$('[data-search-open]').forEach((b) => b.addEventListener('click', openSearch));
  $('[data-search-close]')?.addEventListener('click', closeSearch);
  const sInput = $('[data-search-input]');
  const sResults = $('[data-search-results]');
  let sTimer;
  sInput?.addEventListener('input', () => {
    clearTimeout(sTimer);
    const q = sInput.value.trim();
    if (q.length < 2) { sResults.innerHTML = ''; return; }
    sTimer = setTimeout(async () => {
      try {
        const r = await fetch(`${T.routes.search}/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8`);
        const d = await r.json();
        const products = d.resources?.results?.products || [];
        sResults.innerHTML = products.length ? products.map((p) => `
          <a href="${p.url}" class="group block">
            <div class="aspect-square bg-[#f5f5f5] overflow-hidden mb-3">${p.image ? `<img src="${p.image}&width=400" alt="" class="w-full h-full object-cover luxe-image-hover" loading="lazy">` : ''}</div>
            <p class="font-display text-base text-center">${p.title}</p>
            <p class="font-display text-sm text-muted-foreground text-center">${formatMoney(Math.round(parseFloat(p.price) * 100))}</p>
          </a>`).join('') : '<p class="col-span-full text-center font-display text-lg text-muted-foreground">No results</p>';
      } catch (e) { /* noop */ }
    }, 220);
  });

  /* ---------- Cart drawer ---------- */
  const drawer = $('#CartDrawer');
  const useDrawer = T.cartType !== 'page' && drawer;
  const openDrawer = () => toggleLayer(drawer, 'aside', 'translate-x-full', true);
  const closeDrawer = () => toggleLayer(drawer, 'aside', 'translate-x-full', false);
  $('[data-cart-close]')?.addEventListener('click', closeDrawer);
  drawer?.querySelector('[data-cart-overlay]')?.addEventListener('click', closeDrawer);

  const renderCart = (cart) => {
    $$('[data-cart-count-badge]').forEach((el) => (el.textContent = cart.item_count));
    if (!drawer) return;
    $('[data-cart-count]', drawer).textContent = `(${cart.item_count})`;
    $('[data-cart-subtotal]', drawer).textContent = formatMoney(cart.total_price);
    $('[data-cart-footer]', drawer).classList.toggle('hidden', cart.item_count === 0);
    const list = $('[data-cart-items]', drawer);
    if (!cart.items.length) {
      list.innerHTML = `<div class="h-full flex flex-col items-center justify-center text-center gap-6 py-20">
        <p class="font-display text-xl text-muted-foreground">Your cart is empty</p>
        <a href="${T.routes.root}collections/all" class="luxe-button">Continue Shopping</a></div>`;
      return;
    }
    list.innerHTML = cart.items.map((it, idx) => `
      <div class="flex gap-4 py-5 border-b border-border">
        <a href="${it.url}" class="w-20 h-20 flex-shrink-0 bg-[#f5f5f5] overflow-hidden">${it.image ? `<img src="${it.image}${it.image.includes('?') ? '&' : '?'}width=200" alt="" class="w-full h-full object-cover">` : ''}</a>
        <div class="flex-1 min-w-0">
          <a href="${it.url}" class="font-display text-base block truncate">${it.product_title}</a>
          ${it.product_has_only_default_variant ? '' : `<p class="text-xs text-muted-foreground">${it.variant_title || ''}</p>`}
          <p class="font-display text-sm mt-1">${formatMoney(it.final_line_price)}</p>
          <div class="flex items-center justify-between mt-2">
            <div class="flex items-center border border-border text-sm">
              <button type="button" class="px-3 py-1 hover:bg-secondary" data-line="${idx + 1}" data-qty-to="${it.quantity - 1}" aria-label="Decrease">−</button>
              <span class="px-3">${it.quantity}</span>
              <button type="button" class="px-3 py-1 hover:bg-secondary" data-line="${idx + 1}" data-qty-to="${it.quantity + 1}" aria-label="Increase">+</button>
            </div>
            <button type="button" class="text-xs tracking-[0.15em] uppercase underline underline-offset-4 text-muted-foreground hover:text-foreground" data-line="${idx + 1}" data-qty-to="0">Remove</button>
          </div>
        </div>
      </div>`).join('');
  };

  const getCart = () => fetch(`${T.routes.cart}.js`).then((r) => r.json());
  const refreshCart = async (open) => { const c = await getCart(); renderCart(c); if (open) openDrawer(); };

  drawer?.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-line]');
    if (!b) return;
    b.disabled = true;
    const r = await fetch(`${T.routes.cartChange}.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: +b.dataset.line, quantity: Math.max(0, +b.dataset.qtyTo) })
    });
    renderCart(await r.json());
  });

  if (useDrawer) {
    $$('[data-cart-open]').forEach((a) => a.addEventListener('click', (e) => { e.preventDefault(); refreshCart(true); }));
  }

  const addToCart = async (form, btn) => {
    const label = btn?.innerHTML;
    if (btn) { btn.disabled = true; btn.innerHTML = '<span class="inline-block w-4 h-4 border border-current border-t-transparent rounded-full animate-spin"></span>'; }
    try {
      const r = await fetch(`${T.routes.cartAdd}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const d = await r.json();
      if (!r.ok) throw new Error(d.description || d.message || 'Could not add to cart');
      if (useDrawer) await refreshCart(true); else window.location.href = T.routes.cart;
    } catch (err) {
      alert(err.message);
    } finally {
      if (btn) { btn.disabled = false; btn.innerHTML = label; }
    }
  };

  document.addEventListener('submit', (e) => {
    const f = e.target;
    if (f.matches('[data-quick-add], [data-product-form]')) {
      e.preventDefault();
      addToCart(f, f.querySelector('[type="submit"]'));
    }
  });

  /* ---------- Shuffle (FeaturedProducts / Accessories) ---------- */
  $$('[data-shuffle]').forEach((grid) => {
    const n = +grid.dataset.shuffle;
    const items = $$('[data-shuffle-item]', grid);
    for (let i = items.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [items[i], items[j]] = [items[j], items[i]]; }
    items.forEach((el, i) => { el.hidden = i >= n; grid.appendChild(el); });
  });

  /* ---------- Product carousel (replaces Embla) ---------- */
  $$('[data-carousel]').forEach((c) => {
    const track = $('[data-carousel-track]', c);
    const slides = $$('[data-carousel-slide]', c);
    const dotsWrap = $('[data-carousel-dots]', c);
    if (!slides.length) return;
    let i = 0;
    const dots = slides.slice(0, 5).map((_, k) => {
      const d = document.createElement('button');
      d.type = 'button'; d.className = 'w-8 h-0.5 transition-colors bg-foreground/20'; d.setAttribute('aria-label', `Go to product ${k + 1}`);
      d.addEventListener('click', () => go(k));
      dotsWrap.appendChild(d); return d;
    });
    const go = (k) => {
      i = (k + slides.length) % slides.length;
      track.style.transform = `translateX(-${i * 100}%)`;
      slides.forEach((s, j) => (s.style.opacity = j === i ? '1' : '0.5'));
      dots.forEach((d, j) => { d.classList.toggle('bg-foreground', j === i % 5); d.classList.toggle('bg-foreground/20', j !== i % 5); });
    };
    $('[data-carousel-prev]', c).addEventListener('click', () => go(i - 1));
    $('[data-carousel-next]', c).addEventListener('click', () => go(i + 1));
    let x0 = null;
    track.addEventListener('touchstart', (e) => (x0 = e.touches[0].clientX), { passive: true });
    track.addEventListener('touchend', (e) => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1)); x0 = null; });
    go(0);
  });

  /* ---------- Parallax (replaces framer-motion useScroll) ---------- */
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const parallax = $$('[data-parallax]');
  if (parallax.length && !reduce) {
    const tick = () => {
      const vh = window.innerHeight;
      parallax.forEach((img) => {
        const sec = img.closest('[data-parallax-section]') || img.parentElement;
        const r = sec.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        const p = 1 - (r.bottom / (vh + r.height)); // 0 → 1
        const amt = +img.dataset.parallax || 10;
        img.style.transform = `translateY(${(-amt + p * amt * 2).toFixed(2)}%)${img.classList.contains('scale-110') ? ' scale(1.1)' : ''}`;
      });
    };
    let raf; window.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(tick); }, { passive: true });
    tick();
  }

  /* ---------- Reveal on scroll (replaces whileInView) ---------- */
  const reveals = $$('[data-reveal]');
  if ('IntersectionObserver' in window && !reduce) {
    const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } }), { rootMargin: '-50px' });
    reveals.forEach((el) => io.observe(el));
  } else reveals.forEach((el) => el.classList.add('is-visible'));

  /* ---------- Product page ---------- */
  const pRoot = $('[data-product]');
  if (pRoot) {
    const product = JSON.parse($('[data-product-json]', pRoot).textContent);
    const form = $('[data-product-form]', pRoot);
    const idInput = $('[data-variant-id]', pRoot);
    const addBtn = $('[data-add-button]', pRoot);

    const showMedia = (idx) => {
      $$('[data-media]', pRoot).forEach((m) => m.classList.toggle('hidden', +m.dataset.media !== idx));
      $$('[data-thumb]', pRoot).forEach((t) => {
        const on = +t.dataset.thumb === idx;
        t.classList.toggle('border-foreground', on); t.classList.toggle('shadow-md', on); t.classList.toggle('border-transparent', !on);
      });
    };
    $$('[data-thumb]', pRoot).forEach((t) => t.addEventListener('click', () => showMedia(+t.dataset.thumb)));

    const update = () => {
      const opts = product.options.map((_, i) => $(`input[data-option-index="${i}"]:checked`, pRoot)?.value);
      const v = product.variants.find((vv) => vv.options.every((o, i) => o === opts[i]));
      if (!v) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      $('[data-price]', pRoot).textContent = formatMoney(v.price);
      const cmp = $('[data-compare]', pRoot);
      cmp.hidden = !(v.compare_at_price > v.price); cmp.textContent = formatMoney(v.compare_at_price || 0);
      const sku = $('[data-sku]', pRoot); sku.hidden = !v.sku; $('[data-sku-value]', pRoot).textContent = v.sku || '';
      addBtn.disabled = !v.available; addBtn.textContent = v.available ? 'Add to Cart' : 'Sold Out';
      if (v.featured_media) {
        const m = $(`[data-media][data-media-id="${v.featured_media.id}"]`, pRoot);
        if (m) showMedia(+m.dataset.media);
      }
      const url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url);
    };
    $$('input[data-option-index]', pRoot).forEach((i) => i.addEventListener('change', update));

    const q = $('[data-qty] input', pRoot);
    $('[data-qty-minus]', pRoot)?.addEventListener('click', () => (q.value = Math.max(1, (+q.value || 1) - 1)));
    $('[data-qty-plus]', pRoot)?.addEventListener('click', () => (q.value = (+q.value || 1) + 1));

    const zoom = $('#ZoomModal');
    $$('[data-zoom]', pRoot).forEach((a) => a.addEventListener('click', (e) => {
      e.preventDefault();
      $('[data-zoom-img]', zoom).src = a.href;
      zoom.classList.remove('hidden'); zoom.classList.add('flex');
    }));
    zoom?.addEventListener('click', (e) => { if (e.target === zoom || e.target.closest('[data-zoom-close]')) { zoom.classList.add('hidden'); zoom.classList.remove('flex'); } });
  }

  /* ---------- Related products (section rendering) ---------- */
  $$('[data-related-url]').forEach(async (el) => {
    if (el.children.length) return;
    try {
      const html = await fetch(el.dataset.relatedUrl).then((r) => r.text());
      const inner = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-related-url]');
      if (inner) el.innerHTML = inner.innerHTML;
    } catch (e) { /* noop */ }
  });

  /* ---------- Contact form: prefill from ?product= ---------- */
  const pre = new URLSearchParams(location.search).get('product');
  const body = $('[data-prefill-product]');
  if (pre && body && !body.value) body.value = `I'd like to enquire about: ${pre}\n\n`;
})();

/* Policy titles to match brand wording */
(function(){var h=document.querySelector('.shopify-policy__title h1');if(!h)return;var m={'refund-policy':'Returns Policy','shipping-policy':'Shipping Policy','terms-of-service':'Terms & Conditions','privacy-policy':'Privacy Policy','contact-information':'Contact Information','legal-notice':'Legal Notice'};var k=location.pathname.split('/').pop();if(m[k]){h.textContent=m[k];document.title=m[k]+' – Sasha Jameson Interiors';}})();
